/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The available sort by criteria to choose from.
 */
export type PlatformCatalogSortByParam =
  (typeof PlatformCatalogSortByParam)[keyof typeof PlatformCatalogSortByParam];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlatformCatalogSortByParam = {
  NAME_ASC: "NAME_ASC",
  NAME_DESC: "NAME_DESC",
  UPDATED_AT_ASC: "UPDATED_AT_ASC",
  UPDATED_AT_DESC: "UPDATED_AT_DESC",
} as const;
